$('body').on('click', '.add-story-trigger', function() {
    openModal('.add-story');
    return false;
});


var storyLinkItem = `<div class="link-item item">
    <a href="" class="remove-link-item-trigger remove-item-trigger icon-trash" tabindex="-1"></a>
    <a href="" class="add-link-item-trigger-before add-item-before-trigger icon-add" tabindex="-1"></a>

    <ul class="fields no-padding">
        <li class="half">
            <input type="text" name="link[]" class="required">
            <span>Link</span>
        </li>

        <li class="half last">
            <input type="text" name="label[]" class="required">
            <span>Label</span>
        </li>
    </ul>
</div>`;

$('body').on('click', '.add-story .add-link-item-trigger, .edit-story .add-link-item-trigger', function () {
    var $this = $(this);
    var modal = $this.parents('.add-story, .edit-story');
    modal.find('.setup-link-items').append(storyLinkItem);
    return false;
});

$('body').on('click', '.add-story .add-link-item-trigger-before, .edit-story .add-link-item-trigger-before', function () {
    var $this = $(this);
    // var modal = $this.parents('.add-story, .edit-story');
    $this.parents('.link-item').before(storyLinkItem);
    return false;
});

$('body').on('click', '.add-story .remove-link-item-trigger, .edit-story .remove-link-item-trigger', function () {
    var $this = $(this);
    $this.parents('.link-item').remove();
    return false;
});

$('body').on('keydown', '.add-story input[name="label[]"], .edit-story input[name="label[]"]', function (e) {
    if (e.keyCode === 9) {
        var $this = $(this);
        if ($this.parents('.link-item').is(':last-child')) {
            e.preventDefault();
            var modal = $this.parents('.add-story, .edit-story');
            modal.find('.add-link-item-trigger').trigger('click');
            $this.parents('.link-item').next().find('input[type="text"]').focus();
        }
    }
});


$("body").on("click", ".open-story-menu", function () {
    var $this = $(this);
    var menu = $this.parents(".story-menu-wrapper");

    $(".story-menu", menu).css({
        top: menu.position().top,
        left:
            5 + (menu.position().left + menu.width()) - $(".story-menu", menu).width()
    });

    menu.addClass("opened");
    closeDropdown($this.parents(".story-menu-wrapper").attr("data-dropdown"));
    return false;
});

$('body').on('click', '.edit-story-trigger', function() {
    var data = $(this).parents('.story');
    var action = $('.edit-story form').attr('data-action').replace('{story}', data.attr('data-story'));
    $('.edit-story form').attr('action', action);

    $('.edit-story [name="title"]').val(data.attr('data-title'));
    $('.edit-story [name="embed_url"]').val(data.attr('data-embed_url'));
    $('.edit-story [name="publish_date"]').val(data.attr('data-publish_date'));
    $('.edit-story [name="day"]').val(data.attr('data-day'));
    $('.edit-story [name="month"]').val(data.attr('data-month'));
    $('.edit-story [name="year"]').val(data.attr('data-year'));
    $('.edit-story [name="week"]').val(data.attr('data-week'));
    $('.edit-story [name="description"]').val(data.attr('data-description'));
    $('.edit-story [name="excerpt"]').val(data.attr('data-excerpt'));
    $('.edit-story [name="published"]').prop('checked', data.attr('data-published') ? true : false);

    fileUploaderRemoveFile($('.edit-story .file-uploader[data-file="asset"]'));
    if (data.attr('data-asset')) {
        fileUploaderAddFile($('.edit-story .file-uploader[data-file="asset"]'), data.attr('data-asset_name'), data.attr('data-asset'));
    }
    
    var linkItems = JSON.parse(data.attr('data-links'));
    $('.edit-story .setup-link-items').html('');
    $.each(linkItems, function (index, linkItem) {
        $('.setup-link-items').append(`<div class="link-item item">
            <a href="" class="remove-link-item-trigger remove-item-trigger icon-trash" tabindex="-1"></a>
            <a href="" class="add-link-item-trigger-before add-item-before-trigger icon-add" tabindex="-1"></a>

            <ul class="fields no-padding">
                <li class="half filled">
                    <input type="text" name="link[]" class="required" value="${linkItem.link}">
                    <span>Link</span>
                </li>

                <li class="half filled last">
                    <input type="text" name="label[]" class="required" value="${linkItem.label}">
                    <span>Label</span>
                </li>
            </ul>
        </div>`);
    });

    openModal('.edit-story');
    closeDropdown();
    return false;
});

$('body').on('submit', '.add-story form, .edit-story form', function() {
    var $this = $(this);
    var modal = $this.parents('.modal');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    modal.find('.required').each(function() {
        var input = $(this);

        if(input.attr('type') === 'radio') {
            if(!modal.find('input[name="'+input.attr('name')+'"]:checked').length) {
                error = true;
            }
        }

        if(input.attr('type') === 'checkbox') {
            if(!input.prop('checked')) {
                error = true;
            }
        }

        if(input.val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});


channel.bind('process-story', function(data) {
    // console.log(data);
    var element;

    if($('.story[data-story="'+data.story+'"]').length) {
        element = $('.story[data-story="'+data.story+'"]');

        element.attr('data-asset', data.asset);
        element.attr('data-asset_name', data.asset_name);
        element.attr('data-asset_file_name', data.asset_file_name);
        element.attr('data-asset_url', data.asset_url);
        element.attr('data-asset_type', data.asset_type);
        element.attr('data-title', data.title);
        element.attr('data-embed_url', data.embed_url);
        element.attr('data-slug', data.slug);
        element.attr('data-description', data.description);
        element.attr('data-excerpt', data.excerpt);
        element.attr('data-day', data.day);
        element.attr('data-month', data.month);
        element.attr('data-year', data.year);
        element.attr('data-week', data.week);
        element.attr('data-links', JSON.stringify(data.links));
        element.attr('data-published', data.published);
        element.attr('data-publish_date', data.publish_date);

        element.find('[data-input="title"]').html(data.title);
        element.find('[data-input="short_url"]').html(data.short_url);
        element.find('[data-input="slug"]').html(data.slug);
        element.find('[data-input="day"]').html(data.day);
        element.find('[data-input="month"]').html(data.month);
        element.find('[data-input="year"]').html(data.year);
        element.find('[data-input="week"]').html(data.week);
        element.find('[data-input="links_count"]').html(data.links_count);
        element.find('[data-input="publish_date_parsed"]').html(data.publish_date_parsed);
        element.find('[data-input="status"]').html(data.status);
        element.find('[data-input="status"]').attr('data-color', data.status_color);
        element.find('[data-input="total_slides"]').html(data.total_slides);
        element.find('.menu').html(buttons(data.buttons));
        return;
    }

    if($('body').attr('data-page') === '1') {
        element = $('<tr>', {
            class: 'story',
            'data-asset': data.asset,
            'data-asset_name': data.asset_name,
            'data-asset_file_name': data.asset_file_name,
            'data-asset_url': data.asset_url,
            'data-asset_type': data.asset_type,
            'data-title': data.title,
            'data-slug': data.slug,
            'data-embed_url': data.embed_url,
            'data-description': data.description,
            'data-excerpt': data.excerpt,
            'data-day': data.day,
            'data-month': data.month,
            'data-year': data.year,
            'data-week': data.week,
            'data-links': JSON.stringify(data.links),
            'data-published': data.published,
            'data-publish_date': data.publish_date
        });

        element.append(`<td>
            <p data-input="title">${data.title}</p>
            <p class="small-text" data-input="slug">${data.slug}</p>
        </td>

        <td data-input="short_url">${data.short_url}</td>

        <td>
            <span data-input="day">${data.day}</span>
            <span data-input="month">${data.month}</span>
            <span data-input="year">${data.year}</span>
            <span data-input="week">${data.week}</span>
        </td>

        <td data-input="links_count">${data.links_count}</td>
        <td data-input="total_slides">${data.total_slides}</td>
        
        <td><span class="highlight" data-color="${data.status_color}" data-input="status">${data.status}</span></td>

        <td data-input="publish_date_parsed">${data.publish_date_parsed}</td>
        <td class="story-menu-wrapper menu-wrapper" data-dropdown="story-${data.story}">
            <a href="" class="icon-more open-story-menu open-menu"></a>
            <ul class="story-menu menu">
                 ${buttons(data.buttons)}
            </ul>
        </td>`);

        $('.stories tbody').prepend(element);
    }
});